import { IState } from '../../store';
import { IRosreestrItem } from '../../types/rosreestr';

export function selectRosreestrItems(state: IState): IRosreestrItem[] {
  if (!state.rosreestr) {
    return [];
  }

  return state.rosreestr.items;
}
